import { useMemo } from 'react';
import { AccountStatus } from '@common-fe/common-fe';

import { PaymentMethod, PaymentMethodType } from '@/modules/employee/employee.types';
import { BankFields } from '@/modules/ReimburseMe/ConfirmationStep/Immediately/DirectDeposit/BankForm/useBankFields';
import { useGetBankAccountByIdQuery } from '@/modules/ReimburseMe/ConfirmationStep/Immediately/DirectDeposit/BankForm/useGetBankAccountsList.query';

export const usePaymentMethodHasPendingMessage = (paymentMethod?: Partial<PaymentMethod>, enabled?: boolean) => {
  const isDirectDeposit = useMemo(() => paymentMethod?.type === PaymentMethodType.DIRECT_DEPOSIT, [paymentMethod]);
  const { currentBankAccount, isLoading } = useGetBankAccountByIdQuery(isDirectDeposit && enabled ? paymentMethod?.accountId : undefined);

  const hasAccountVerificationPendingMessage = useMemo(() => {
    const accountStatus = currentBankAccount?.[BankFields.accountStatus];
    const isAccountInPendingStatus = accountStatus && accountStatus === AccountStatus.PENDING;

    return isAccountInPendingStatus && enabled;
  }, [currentBankAccount, enabled]);

  return { hasAccountVerificationPendingMessage, isLoading };
};
